


































































































import MExpansion from "@/components/utility/mmmint/MExpansion.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { CustomerContractRate, ICustomerContractRate } from "@/models/customer-contract-rate.entity";
import { IReport } from "@/models/report.entity";
import { VehicleInsuranceContract } from "@/models/vehicle-contract.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync } from "vue-property-decorator";

@Component({
  components: { MTextField, MExpansion, MNoContent },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RentalApprovalLimitsSheet extends mixins(PermissionMixin) {
  @Prop({ required: true }) readonly value!: IReport;
  @PropSync("rentalCarDailyRate", { type: Number, default: 0 }) readonly rentalCarDailyRateLocal!: number;
  @PropSync("rentalCarDays", { type: Number, default: 0 }) readonly rentalCarMaxLocal!: number;

  showCustomerContract = true;
  showInsuranceContract = true;

  /**
   * Minimal approach: no watchers. Two computeds that depend on
   * reactive sources used in parent (vehicle/fleet + loading flags + accidentDate).
   */
  get activeInsuranceContract(): VehicleInsuranceContract | undefined {
    const v = this.value?.vehicle;
    void (v && v.loading);
    const raw = v?.activeInsuranceContract(this.value?.accidentDate);
    return raw ? new VehicleInsuranceContract(raw) : undefined;
  }

  get activeCustomerContract(): ICustomerContractRate | undefined {
    const f = this.value?.fleet;
    void (f && f.isLoadingContracts);
    const raw = f?.activeCustomerContract(this.value?.accidentDate);
    if (raw && (raw as any).details) {
      const details = (raw.details as unknown) as ICustomerContractRate;
      return new CustomerContractRate(details);
    }
    return undefined;
  }

  get isApprovalLimits(): boolean {
    const c = this.activeCustomerContract;
    const i = this.activeInsuranceContract;

    const hasCustomerValues =
      !!c?.comprehensiveRentalCarDefault || !!c?.rentalCarVIPDefault || !!c?.rentalCarThirdPartyDamageDefault;

    const hasInsuranceValues = !!i?.rentalCarDailyRateReadable || !!i?.rentalCarMaxDays;

    return hasCustomerValues || hasInsuranceValues;
  }

  get isDailyRateNotCovered() {
    if (!this.rentalCarDailyRateLocal) {
      return false;
    }

    const coveredRate = this.activeInsuranceContract?.rentalCarDailyRate || 0;

    if (this.rentalCarDailyRateLocal > coveredRate) {
      return true;
    }
    return false;
  }

  get isMaxDaysNotCovered() {
    if (!this.rentalCarMaxLocal) {
      return false;
    }

    const coveredRate = this.activeInsuranceContract?.rentalCarMaxDays || 0;

    if (this.rentalCarMaxLocal > coveredRate) {
      return true;
    }
    return false;
  }
}
